import AuthHttpService from "./AuthHttpService";

interface IUpdateParams {
  path: string;
  value: any;
}

export default class VisitorService extends AuthHttpService {
  public constructor(readonly url?: string) {
    super(url);
  }

  async updateVisitorInfo(params: IUpdateParams[]) {
    return await this.patch("v1/me", { operations: params });
  }

  async verifyUserProfile(verifyData: FormData) {
    return await this.post("v1/me/verify-profile", verifyData);
  }
}
